import { createFileRoute, Navigate } from '@tanstack/react-router';
import { type ReactElement } from 'react';

import { useSettingsGates } from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/automations')({
    component: AutomationsPage,
});

function AutomationsPage(): ReactElement | null {
    const { isLoading, gates } = useSettingsGates();
    if (isLoading) {
        return null;
    }
    if (!gates.canManageOrgSettings || !gates.agentV3) {
        return <Navigate to="/home" replace={true} />;
    }
    return <Navigate to="/settings/configurations" replace={true} />;
}
